import host from './host.js';
import request from '@/utils/request.js';
import qs from 'qs';

const order = {
    getcityTree() { //获取省市区树
        return request.post(host.test + '/Kitchen/ShopGoods/GetCityTree');
    },
    getAddress(params) { //获取用户收货地址
        return request.post(host.test + '/Kitchen/ShopGoods/GetUserAddressList', params);
    },
    joinAddress(params) { //添加收货地址
        return request.post(host.test + '/Kitchen/ShopGoods/AddUserAddress', params);
    },
    editAddress(params) { //用户编辑收货地址
        return request.post(host.test + '/Kitchen/ShopGoods/EditUserAddress', params);
    },
    delAddress(params) { //用户删除收货地址
        return request.post(host.test + '/Kitchen/ShopGoods/DelUserAddress/' + params);
    },
    setdefaultAddress(params) { //设置收货地址为默认地址
        return request.post(host.test + '/Kitchen/ShopGoods/SetDefaultAddress/' + params);
    },
    getPayqrcode(params) { //下单扫码支付接口
        let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
        params['vegetable_market_id'] = 0
        if (marketActObj) params.vegetable_market_id = marketActObj.id
        return request.post(host.test + '/Kitchen/Order/GetPayQrcode', params);
    },
    getUserRechargeList(params) { //获取用户充值记录
        return request.post(host.test + '/Kitchen/Balances/GetUserRechargeList', params);
    },
    UserRecharge(params) { //用户充值
        return request.post(host.test + '/Kitchen/Balances/UserRecharge', params);
    },
    orderList(params) { //我的订单
        return request.post(host.test + '/Kitchen/Order/GetUserProductOrderList', params);
    },
    UserBalances() { //查询用户余额
        return request.post(host.test + '/Kitchen/Balances/GetUserBalances');
    },
    buyAgaindata(params) {
        return request.post(host.test + '/Kitchen/Order/GetUserProductByOrderId/' + params);
    },
    AddOrderByIntegral(params) {
        return request.post(host.test + '/Kitchen/Order/AddOrderByIntegral', params);
    },
    GetUserVouchersLog(params) {
        return request.post(host.test + '/Kitchen/Balances/GetUserVouchersLog', params);
    },
    GetUserIntegralProductOrderList(params) {
        return request.post(host.test + '/Kitchen/Order/GetUserIntegralProductOrderList', params);
    },
    AddOrderByIntegralGood(params) {
        return request.post(host.test + '/Kitchen/Order/AddOrderByIntegralGood', params);
    },
    GetRegionIdByCityName(params) {
        return request.post(host.test + '/Kitchen/KitchenUser/GetRegionIdByCityName', params);
    },
    GetMarkets(params) {
        return request.post(host.test + '/Kitchen/ShopGoods/GetMarkets', params);
    },
    GetOrderDeliveryFee(params) {
        return request.post(host.test + '/Kitchen/Order/GetOrderDeliveryFee', params);
    },
    


}

export default order;